import { create } from "zustand";

let _holdTimer;

export const PRODUCTS = {
  airpods: { id: "airpods", name: "Apple AirPods Pro", tag: "Spatial Audio", url: "/models/airpods_meshy.glb" },
  melasyl: { id: "melasyl", name: "L'Oréal Melasyl", tag: "Dermo-Science", url: null },
  lotus: { id: "lotus", name: "Lotus Ring", tag: "Smart Wearable", url: null },
};

export const MELASYL_MODELS = {
  closed: "/models/melasyl_closed.glb",
  open: "/models/melasyl_open.glb",
};

export const RING_VARIANTS = {
  graphite: { label: "Graphite", url: "/models/ring_graphite.glb", swatch: "#2A2E36" },
  rosegold: { label: "Rose Gold", url: "/models/ring_rose.glb", swatch: "#E0A899" },
  silver: { label: "Silver", url: "/models/ring_silver.glb", swatch: "#D6DADF" },
};

export const useStore = create((set) => ({
  entered: false,
  setEntered: (v) => set({ entered: v }),

  product: "airpods",
  setProduct: (p) => set({ product: p, mobilePanel: null }),

  // mobile panel drawer: null | 'controls' | 'product'
  mobilePanel: null,
  setMobilePanel: (v) => set({ mobilePanel: v }),

  // global 3D controls
  autoRotate: true,
  setAutoRotate: (v) => set({ autoRotate: v }),
  rotateHold: false, // transient pause while interacting
  bump: () => {
    set({ rotateHold: true });
    clearTimeout(_holdTimer);
    _holdTimer = setTimeout(() => set({ rotateHold: false }), 3000);
  },
  holdRotation: () => {
    set({ rotateHold: true });
    clearTimeout(_holdTimer);
  },
  rotateSpeed: 1,
  setRotateSpeed: (v) => set({ rotateSpeed: v }),
  explode: 0,
  setExplode: (v) => set({ explode: v }),
  shading: "shaded", // shaded | wireframe | xray
  setShading: (v) => set({ shading: v }),
  opacity: 1,
  setOpacity: (v) => set({ opacity: v }),
  resetKey: 0,
  resetCamera: () => set((s) => ({ resetKey: s.resetKey + 1 })),

  // airpods
  airpodSelect: "both", // last pod selected (for viz accent)
  setAirpodSelect: (v) => set({ airpodSelect: v }),
  lidOpen: true,
  leftOut: false,
  rightOut: false,
  pickPod: (side) =>
    set((s) => {
      if (side === "both") return { lidOpen: true, leftOut: true, rightOut: true, airpodSelect: "both" };
      return { lidOpen: true, [side === "left" ? "leftOut" : "rightOut"]: true, airpodSelect: side };
    }),
  setLid: (open) =>
    set(open ? { lidOpen: true } : { lidOpen: false, leftOut: false, rightOut: false }),
  spatialAudio: true,
  setSpatialAudio: (v) => set({ spatialAudio: v }),
  anc: "anc", // anc | transparency | adaptive
  setAnc: (v) => set({ anc: v }),
  eq: { bass: 62, mid: 48, treble: 56, spatial: 74 },
  setEq: (k, v) => set((s) => ({ eq: { ...s.eq, [k]: v } })),
  showEar: false,
  setShowEar: (v) => set({ showEar: v }),

  // melasyl
  melasylState: "closed", // closed | open | dropper | applied
  setMelasylState: (v) => set({ melasylState: v, dropperActive: v === "applied" }),
  routine: "day", // day | night
  setRoutine: (v) => set({ routine: v }),
  dropperActive: false,
  setDropperActive: (v) => set({ dropperActive: v }),
  skinIntensity: 45,
  setSkinIntensity: (v) => set({ skinIntensity: v }),
  fitz: 3, // Fitzpatrick I-VI
  setFitz: (v) => set({ fitz: v }),

  // lotus
  variant: "graphite",
  setVariant: (v) => set({ variant: v }),
  skinTone: "medium", // light | medium | tan | deep
  setSkinTone: (v) => set({ skinTone: v }),
  ringSize: 8,
  setRingSize: (v) => set({ ringSize: v }),
  tryOn: false,
  setTryOn: (v) => set({ tryOn: v }),
  flashlight: false,
  tv: false,
  lock: false,
  toggleDevice: (k) => set((s) => ({ [k]: !s[k], tryOn: true })),
  haptic: "pulse", // pulse | wave | sos
  setHaptic: (v) => set({ haptic: v }),

  // webxr capability (shared; detected once in Showroom)
  xrAR: null,
  xrVR: null,
  setXrSupport: (ar, vr) => set({ xrAR: ar, xrVR: vr }),

  // audio commentary
  playing: false,
  setPlaying: (v) => set({ playing: v }),
  volume: 72,
  setVolume: (v) => set({ volume: v }),
  progress: 0,
  duration: 78,
  setProgress: (v) => set({ progress: v }),
  setDuration: (v) => set({ duration: v }),
}));
